import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import type { Messaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCqQJkhLcHC7Aeo_EjSqssl86gruvR-64k",
  authDomain: "dehub-ff4a0.firebaseapp.com",
  projectId: "dehub-ff4a0",
  storageBucket: "dehub-ff4a0.firebasestorage.app",
  messagingSenderId: "128939180308",
  appId: "1:128939180308:web:b6315b96f367dc1ae0c201",
  measurementId: "G-1VPVMH0EXF",
};

const app = initializeApp(firebaseConfig);

export const getMessagingInstance = async (): Promise<Messaging | null> => {
  try {
    const supported = await isSupported();
    if (!supported) return null;
    return getMessaging(app);
  } catch {
    return null;
  }
};
